import { HStack } from '@chakra-ui/react';
import { Modal, ModalBody, Button, Card, CardTitle } from 'components/UI';

type AddParameterProps = {
  addParameter: (key: string | number, type: string, copyCurrentModel?: object) => void;
  onCancel: () => void;
  parameterList: (string | boolean | string[])[][];
};

const AddParameter = ({ addParameter, onCancel, parameterList }: AddParameterProps) => {
  const pListArray = parameterList.reduce(
    (acc: number[], item) => [
      ...acc,
      ...(item[1] as string[])
        .filter((value) => typeof value !== 'boolean' && !Array.isArray(value))
        .map((value) => +value),
    ],
    []
  );

  const max = pListArray.reduce((a, b) => Math.max(a, b), 0) + 1;
  const condKey = max.toString();

  const addConditionParameter = (parameterType: string) => addParameter(condKey, parameterType);

  return (
    <Modal isOpen isCloseButton closeOnEsc={false} closeOnOverlayClick isCentered size="xl" onClose={onCancel}>
      <ModalBody pb={6}>
        <Card mt={6} textAlign="center" fontSize="3xl" borderTopRadius={5}>
          Select Parameter Type
        </Card>
        <CardTitle mt={-2} borderBottomRadius={5}>
          <Button w={28} variant="solid" size="sm" onClick={() => addConditionParameter('driving')}>
            DRIVING
          </Button>
          <Button w={28} variant="solid" size="sm" onClick={() => addConditionParameter('reference')}>
            REFERENCE
          </Button>
          <Button w={28} variant="solid" size="sm" onClick={() => addConditionParameter('note')}>
            NOTE
          </Button>
        </CardTitle>
        <HStack justifyContent="center">
          <Button mt={2} variant="solid" size="sm" onClick={onCancel}>
            CANCEL
          </Button>
        </HStack>
      </ModalBody>
    </Modal>
  );
};

export default AddParameter;
